import React, {useEffect, useState} from 'react';
import '../../../styles/serverBlock.scss';
import ServerContentEmpty from './ServerContentEmpty';
import ServerContentDone from './ServerContentDone';
import SavedIcon from './SavedIcon';
import {AiOutlineRight} from 'react-icons/ai';
import {Link} from 'react-router-dom';

const ServerBlock = ({item}) => {
  const [isServerLoadList, setIsServerLoadList] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsServerLoadList(true);
    }, 3000);
  }, []);

  return (
    <div className={isServerLoadList ? `server_wraper ${item?.colorBlock}` : 'server_wraper_none'}>
      <div className="server_wraper_header">
        <div className="server_save_item">
          {/* <img src="./img/server/Saved.svg" alt="Saved.svg" /> */}
          <SavedIcon />
        </div>
      </div>
      <div className="server_wraper_middle">
        {!isServerLoadList ? (
          <ServerContentEmpty />
        ) : (
          <Link to={`/dashboard/${item?.guildId}`}>
            <ServerContentDone item={item} />
          </Link>
        )}
      </div>
      <div className="server_wraper_footer">
        <div className="server_go-to_item-one">
          {/* <img src="./img/server/Next Button.svg" alt="Saved.svg" /> */}
          <AiOutlineRight />
        </div>
      </div>
    </div>
  );
};

export default ServerBlock;
